/** Primary time-slot tabs on /news */
export const TIME_SLOTS = [
  { slug: 'hourly', label: 'Hourly', shortLabel: 'Hourly', path: '/news', kind: 'report' },
  { slug: 'morning', label: 'Morning', shortLabel: 'AM', path: '/news/morning', kind: 'report' },
  {
    slug: 'mid-morning',
    label: 'Mid-Morning',
    shortLabel: 'Mid-AM',
    path: '/news/mid-morning',
    kind: 'report',
  },
  { slug: 'lunch', label: 'Lunch', shortLabel: 'Lunch', path: '/news/lunch', kind: 'report' },
  { slug: 'mid-day', label: 'Mid-Day', shortLabel: 'Mid-Day', path: '/news/mid-day', kind: 'report' },
  { slug: 'evening', label: 'Evening', shortLabel: 'Eve', path: '/news/evening', kind: 'report' },
  { slug: 'night', label: 'Night', shortLabel: 'Night', path: '/news/night', kind: 'report' },
  {
    slug: 'late-night',
    label: 'Late-Night',
    shortLabel: 'Late',
    path: '/news/late-night',
    kind: 'report',
  },
];

/** Topic digests — reachable from Hourly compose cards and direct URLs */
export const TOPIC_SECTIONS = [
  { slug: 'politics', label: 'Politics', path: '/news/politics' },
  { slug: 'economics', label: 'Economics', path: '/news/economics' },
  { slug: 'science', label: 'Science', path: '/news/science' },
  { slug: 'health', label: 'Health', path: '/news/health' },
];

/** ET cron hours for pending copy (America/New_York wall clock). Hourly = top of each hour. */
export const REPORT_CRON_HOUR_ET = {
  hourly: 'hourly',
  morning: 6,
  'mid-morning': 9,
  lunch: 12,
  'mid-day': 15,
  evening: 18,
  night: 21,
  'late-night': 0,
};

export function resolvePageMode(sectionParam) {
  if (!sectionParam || sectionParam === 'frontpage') {
    return { ...TIME_SLOTS[0], mode: TIME_SLOTS[0].kind };
  }

  const timeSlot = TIME_SLOTS.find((slot) => slot.slug === sectionParam);
  if (timeSlot) {
    return { ...timeSlot, mode: timeSlot.kind };
  }

  const topic = TOPIC_SECTIONS.find((item) => item.slug === sectionParam);
  if (topic) {
    return { mode: 'topic', ...topic };
  }

  return { mode: 'unknown' };
}

/** Next wall-clock run label in ET for pending report UX (best-effort). */
export function nextReportRunLabel(slug, now = new Date()) {
  const hour = REPORT_CRON_HOUR_ET[slug];
  if (hour == null) return null;
  if (hour === 'hourly') {
    return 'top of each hour ET';
  }

  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/New_York',
    hour: 'numeric',
    minute: 'numeric',
    hour12: false,
    weekday: 'short',
  }).formatToParts(now);
  const currentHour = Number(parts.find((p) => p.type === 'hour')?.value ?? 0);
  const currentMinute = Number(parts.find((p) => p.type === 'minute')?.value ?? 0);

  let daysAhead = 0;
  if (currentHour > hour || (currentHour === hour && currentMinute > 0)) {
    daysAhead = 1;
  }

  const labelHour = hour === 0 ? '12:00 AM' : hour < 12 ? `${hour}:00 AM` : hour === 12 ? '12:00 PM' : `${hour - 12}:00 PM`;
  return daysAhead === 0 ? `today ${labelHour} ET` : `tomorrow ${labelHour} ET`;
}
